import api from '../api'

import {
    fetchFindCoordsByUnitStart,
    fetchFindCoordsByUnitSuccess,
    fetchFindCoordsByUnitFail,
} from '../reducers/endpoints/findCoordsByUnit'
import {take, put, call} from 'redux-saga/effects'

export function* fetchFindCoordsByUnit(mss) {
  console.log(mss)
  const url = `coordenadas/getporunidade/${mss.mss.unit}`

  console.log('URL:::', url)
  //const userToken = localStorage.getItem('token')

  const headerParams = {
    headers: {
  //    Authorization: `Bearer ${ userToken }`
    }
  }

  try {
      console.log('***********-*-*-*-*-*-* findCoords', yield call([api, 'get'], url, headerParams))
    const {data: data} = yield call([api, 'get'], url, headerParams)
    console.log('***************--',data)
    yield put(fetchFindCoordsByUnitSuccess(data))
  } catch (error) {
    console.log('err', error)
    yield put(fetchFindCoordsByUnitFail(error))
  }
}

export function* watchFetchFindCoordsByUnit() {
  while (true) {
    const {
      payload: mss
    } = yield take(fetchFindCoordsByUnitStart)
    yield call(fetchFindCoordsByUnit, mss)
  }
}